import { Injectable } from '@angular/core'
import { apiUrl } from '../../../../config/api-url'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { IJobSearch } from './job-search.interface'

@Injectable({
  providedIn: 'root',
})
export class JobSearchService {
  private _url = apiUrl + '/shared/job-search'

  constructor(private _http: HttpClient) {}

  public searchJobs(query: string): Observable<IJobSearch[]> {
    return this._http.get<IJobSearch[]>(`${this._url}?q=${query}`)
  }
}
